// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"374ddab8","545":"73c5713a","551":"a8c588d1","605":"5af00972","662":"9e387ba5","907":"7ae4b878"}[chunkId] + ".chunk.js";
};